import React from "react";
import "./Technology.css";
import controllerImg from "../controller.png";
import lockImg from "../locks.jpg";
import panelImg from "../panel.jpg";
import rfidImg from "../RFID.png";
import qrImg from "../barcode.png";
import terminalImg from "../terminal.png";
import { NavLink } from "react-router-dom";

const components = [
  {
    image: controllerImg,
    title: "Qeeper Pro Controller",
    description:
      "Controllers are all-in-one network devices that need to be plugged into a power outlet and an ethernet network connection. The controllers are directly connected to the Qeeper cloud server.\n\nThere are currently three generations of Qeeper controllers available. The QL12, the QL24 and the new, compact and more advanced Qeeper PRO controller. This is suitable for controlling 16 wired locks.\n\nThe PRO controller has its own software that makes it possible to work offline and to control locks in the event of a network failure in combination with a Qeeper RFID reader. All communication between the Qeeper server and the controllers is encrypted using the industry standard AES256 encryption algorithm.",
  },
  {
    image: lockImg,
    title: "Wired Electronic Locks",
    description:
      "The Qeeper system works with different electronically wired locks and is not dependent on one particular lock type or brand. For example, it can be useful that the door opens immediately (pop open) or that the door only opens after the user physically activates the door to open (push open). The system automatically recognizes the different types of locks and adjusts accordingly.\n\nExisting projects where electronically wired locks have already been used can be seamlessly taken over by the Qeeper system and optionally provided with a different lock type. Multiple lock types can even be used interchangeably.",
  },
  {
    image: panelImg,
    title: "Qeeper Management Panel",
    description:
      "The Qeeper management software is web-based. No software needs to be installed on devices used to manage the locker system. The management menu is organized in a logical structure and intuitive to use.\n\nFacility managers and service personnel can monitor and manage the Qeeper system from any device with internet access. Built with a responsive design, the web app adapts to any screen size it is opened on, such as a smartphone, tablet, or desktop computer.",
  },
  {
    image: rfidImg,
    title: "Qeeper RFID Reader",
    description:
      "An RFID reader is an optional component and is not strictly necessary for controlling the Qeeper system. In many cases, institutions already have systems that require authentication via RFID, such as access control to the parking lot or the building, payment in the company canteen, use of the printers, etc.\n\nStandard supported RFID systems are Mifare Classic, Desfire EV1/EV2, and Legic 125KHz LF.",
  },
  {
    image: qrImg,
    title: "Barcode / QR-Code Reader",
    description:
      "A barcode/QR code reader is an optional component and is not strictly necessary for controlling the Qeeper system. A QR code is often used for temporary events. The code will be sent by email as a one-time means of authentication, whether or not for a fee. This allows the user to open his/her temporarily assigned locker by scanning the QR code.",
  },
  {
    image: terminalImg,
    title: "Qeeper Touchscreen Terminal",
    description:
      "A touchscreen terminal is an optional component and is not strictly necessary for controlling the Qeeper system. All storage functions are also available via the MyLocker smartphone app. Touchscreen terminals are preferred in locations where the user environment of the locker often changes, where users are not allowed or unwilling to use their smartphone to access the lockers.\n\nThe user interface displayed on the screen is fully customizable to customer needs — the organization's logo, color theme and graphics can be applied. The terminals are also multilingual.",
  },
];

const TechnologyPage = () => (
  <div className="tech-page">
    <header className="page-hero">
      <h1>Technology</h1>
      <p>Innovative components for smart locker solutions.</p>
    </header>

    {components.map((comp, i) => (
      <section
        key={i}
        className={`tech-component${i % 2 !== 0 ? " tech-component--grey" : ""}${i % 2 !== 0 ? " tech-component--reverse" : ""}`}
      >
        <div className="tech-component__inner">
          <div className="tech-component__image">
            <img src={comp.image} alt={comp.title} />
          </div>
          <div className="tech-component__text">
            <h2>{comp.title}</h2>
            <p>{comp.description}</p>
          </div>
        </div>
      </section>
    ))}

    <section className="tech-highlight">
      <div className="tech-highlight__inner">
        <div>
          <h2>Seamless Integration</h2>
          <p>
            Qeeper components are designed to work together, ensuring a cohesive
            and efficient locker system. They are compatible with various
            existing infrastructures, allowing for easy upgrades and expansions.
          </p>
        </div>
        <div>
          <h2>Robust Security</h2>
          <p>
            All Qeeper components utilize industry-standard AES256 encryption,
            ensuring secure communication and full data protection.
          </p>
        </div>
      </div>
    </section>

    <section className="page-cta">
      <h2>Explore Qeeper Technology</h2>
      <p>
        Discover how our innovative components can transform your locker
        solutions.
      </p>
      <NavLink to="/contact" className="page-cta__button">
        Contact us
      </NavLink>
    </section>
  </div>
);

export default TechnologyPage;
